import * as React from "react";

interface IProps {
  identifier: number | string;
  children: React.ReactNode;
}

const Disclaimer = (props: IProps) => {
  const { identifier, children } = props;

  return (
    <div className="disclaimer">
      <sup>{identifier}</sup>
      <div>
        {children}
      </div>
    </div>
  );
};

export default Disclaimer;
